﻿import { FIQAssist } from "../app";
import { IParent, IMediator, IMediatedChild } from "../interfaces/IParentChild";
import { Component, Input, Output, Attribute, Inject } from "@fiqas/angular-utils";

@Component({
    module: FIQAssist,
    selector: 'toggleswitch',
    template: `<div class="toggleswitch ng-class:{hasfocus:$ctrl.hasfocus, readonly:$ctrl.readOnly}" tabindex="{{$ctrl.tabIndex || 0}}"
                ng-keydown="$ctrl.onKeydown($event)" ng-mousedown="$ctrl.toggle($event)" ng-focus="$ctrl.onFocus()" ng-blur="$ctrl.onBlur()">
                    <span class="{{$ctrl.switchClass}}">
                        <span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span>
                    </span>
                </div>`
})
export class Toggleswitch implements IMediatedChild {
    @Input() public readOnly: boolean;
    @Input() public ignoreKeys: boolean;
    private _initialized = false;
    constructor(
        @Inject('$element') private $element: angular.IRootElementService,
        @Inject('$rootScope') private $rootScope: angular.IRootScopeService
    ) {
    }

    public $onInit() {
        this._initialized = true;
        this.$rootScope.$on('eventCleared', (event) => {
            if (this.$element[0].classList.contains('my-service-cases')) {
                this.active = false;
            }
        });
    }

    @Input() tabIndex: number;

    private _parent: IParent = null;
    @Input()
    public set parent(value: IParent) {
        if (value != null && this.parent !== value) {
            this._parent = value;
            this.parent.addChild(this);
            if (this._mediator)
                this._mediator.parent = this._parent;
        }
    }
    public get parent(): IParent {
        return this._parent;
    }

    private _mediator: IMediator = null;
    @Input()
    public set mediator(value: IMediator) {
        if (value != null && this._mediator !== value) {
            this._mediator = value;
            this._mediator.child = this;
            if (this._parent)
                this._mediator.parent = this._parent;
        }
    }
    public get mediator(): IMediator {
        return this._mediator;
    }

    public get switchClass() {
        return `icon-checkbox${this.active ? 'ON' : this.readOnly ? 'DIS' : 'OFF'}${this.hasfocus && !this.readOnly ? '-Focus' : ''}`;
    }

    @Input() public key: any;

    private _active: boolean;

    @Input() public get active() {
        return this._active;
    }
    public set active(val: boolean) {
        var v = this._active;
        this._active = !!val;
        if (this._initialized && v !== val)
            this.activechanged({ source: this, active: val });
    }
    @Output() public activechanged: (args: { source: Toggleswitch, active: boolean }) => void;

    public toggle($event: JQueryEventObject | KeyboardEvent) {
        $event.preventDefault();
        if (!this.hasfocus) {
            this.hasfocus = true;
        }
        if (!this.readOnly) {
            this.active = !this.active;
        }
    }

    public onKeydown($event: KeyboardEvent) {
        if (this.readOnly || this.ignoreKeys)
            return;
        switch ($event.keyCode) {
            case 13:
                break;
            case 32:
                this.toggle($event);
                break;

            case 37:
                $event.preventDefault();
                this.active = false;
                break;

            case 39:
                $event.preventDefault();
                this.active = true;
                break;
        }

    }

    private _focus: boolean = false;
    public get hasfocus() {
        return this._focus;
    }
    public set hasfocus(val: boolean) {
        if (this._focus !== val) {
            if (val && document.activeElement !== this.$element[0]) {
                this.$element[0].querySelector('.toggleswitch').focus();
            }
            this._focus = val;
        }
    }
    private onFocus() {
    }
    private onBlur() {
        this.hasfocus = false;
    }
}

